import { homeHeroMarkup } from "./home/homeHeroMarkup";
import { homeMemberMarkup } from "./home/homeMemberMarkup";
import { homeLearningSectionsMarkup } from "./home/homeLearningSectionsMarkup";
import { homeRecommendationSectionsMarkup } from "./home/homeRecommendationSectionsMarkup";

/**
 * Home markup. The previous homeHeroMarkup opened three wrappers
 * (app-layout, main, view-home) without closing them and the
 * intended </main></div> tail lived in githubTrendingMarkup as a
 * hack. We now wrap the joined prototypeMarkup in those three
 * layers exactly once (in prototypeMarkup.ts) and just close
 * the inner <div id="view-home"> here, so every other view-markup
 * renders as a sibling of view-home instead of a descendant.
 *
 * `homeMetricsMarkup` was removed: its only contents were a
 * member-metrics-strip + resume-card that already live inside
 * `homeLearningSectionsMarkup`. Including both produced 7 sets
 * of duplicate IDs (memberMetricsSection, resumeCard, etc.)
 * inside the same #view-home, which is invalid HTML and
 * confuses querySelector / data-binds.
 */
export const homeMarkup =
  [
    homeHeroMarkup,
    homeMemberMarkup,
    homeLearningSectionsMarkup,
    homeRecommendationSectionsMarkup,
  ].join("") + "</div>";
